import React, { useEffect } from "react";

import { MessageCircleQuestion } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import useChatStore from "@/stores/useChatStore";
import { ReactComponent as AISuggestIcon } from "@/assets/ai-suggest.svg";

function SuggestedQuestion({ scrollToBottom, onQuestionClick, className, isPopupContent }) {
  const suggestedQuestions = useChatStore((store) => store.suggestedQuestions);
  const hasDisplayedAnswer = useChatStore((store) => store.hasDisplayedAnswer);

  useEffect(() => {
    if (hasDisplayedAnswer && suggestedQuestions?.length) {
      scrollToBottom();
    }
  }, [hasDisplayedAnswer, suggestedQuestions?.length]);

  if (!hasDisplayedAnswer || !suggestedQuestions?.length) return null;

  return (
    <div className={cn("mb-8 mt-5", className)}>
      <div className="mt-4 mb-3 flex align-center items-center">
        <MessageCircleQuestion size={18} color="#218BEC" />
        <span className={cn("text-xs ml-1 text-stone-500", isPopupContent ? "text-sm" : "text-md")}>Câu hỏi đề xuất:</span>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {suggestedQuestions.map((question, idx) => (
          <Button
            key={question}
            variant="outline"
            className={cn(
              "h-auto py-2 px-3 ml-1 justify-start text-left flex items-center gap-2",
              "rounded-xl border border-blue-200 bg-gradient-to-br from-blue-50/60 to-white shadow-sm",
              "text-sm font-medium text-slate-800",
              "hover:bg-white focus-visible:ring-2 focus-visible:ring-blue-300",
              "animate-bound-in-up"
            )}
            style={{ animationDelay: `${idx * 50}ms` }}
            onClick={() => onQuestionClick(question)}
          >
            <AISuggestIcon className="w-4 h-4" />
            {question}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default SuggestedQuestion;
